export const getSelectedPassengerUnitIds = ({
  passengerItems,
  selectedPassengerIds,
}: {
  passengerItems: { value?: number | string; unitId?: number | null }[];
  selectedPassengerIds?: number[];
}): (number | null | undefined)[] => {
  if (!selectedPassengerIds) {
    return passengerItems.map(item => item.unitId);
  }

  const selectedIds = new Set<number | string>(selectedPassengerIds);

  return passengerItems
    .filter(item => item.value !== undefined && selectedIds.has(item.value))
    .map(item => item.unitId);
};

export const hasPassengersFromUnaffiliatedUnits = ({
  shiftUnitIds,
  passengerUnitIds,
}: {
  shiftUnitIds?: number[] | null;
  passengerUnitIds: (number | null | undefined)[];
}): boolean => {
  // A shift with no units is open to every unit, and a passenger with no unit never
  // mismatches. This is the matching rule only — the backend's shift filter is additionally
  // gated on the bookingStationShiftConsiderationUnits system param, which this warning
  // does not read.
  if (!shiftUnitIds?.length) {
    return false;
  }

  const allowedUnitIds = new Set(shiftUnitIds);

  return passengerUnitIds.some(
    unitId => !!unitId && !allowedUnitIds.has(unitId),
  );
};
